<div class="container-content">
  <ng-template
    #adminLanguageBlock
    let-titleKey="titleKey"
    let-edit="edit"
    let-start="start"
    let-save="save"
    let-cancel="cancel"
  >
    <div class="question-block">
      <div class="section-bg-contrast">
        <div class="question-header">
          <span>{{ titleKey | translate }}</span>
          <ng-container *ngIf="isAdmin">
            <button
              *ngIf="!edit.active"
              type="button"
              class="btn border-0"
              [attr.aria-label]="'button.edit' | translate"
              (click)="start()"
            >
              <i class="bi bi-pencil-fill" aria-hidden="true"></i>
            </button>
            <div *ngIf="edit.active" class="d-flex gap-2">
              <button
                type="button"
                class="btn btn-sm btn-primary"
                (click)="save()"
                [disabled]="
                  edit.saving ||
                  edit.loadingOptions ||
                  !edit.control.value
                "
              >
                {{ 'button.save' | translate }}
              </button>
              <button
                type="button"
                class="btn btn-sm btn-outline-secondary"
                (click)="cancel()"
                [disabled]="edit.saving"
              >
                {{ 'button.cancel' | translate }}
              </button>
            </div>
          </ng-container>
        </div>
      </div>

      <div
        class="spinner-border text-info mb-3"
        role="status"
        *ngIf="edit.active && edit.loadingOptions"
      >
        <span class="visually-hidden">Loading...</span>
      </div>

      <app-form-field-select
        *ngIf="isAdmin && edit.active && !edit.loadingOptions"
        [field]="edit.control"
        [options]="edit.options"
        [label]="'label.dropdown-select'"
        [multiple]="false"
        [required]="true"
      ></app-form-field-select>

      <div class="plain-text-output" *ngIf="!edit.active">
        <span>{{
          userAnswers.language
            ? (userAnswers.language | translate)
            : ('label.not-specified' | translate)
        }}</span>
      </div>
    </div>
  </ng-template>

  <ng-template
    #adminUniversitiesBlock
    let-titleKey="titleKey"
    let-edit="edit"
    let-start="start"
    let-save="save"
    let-cancel="cancel"
    let-items="items"
  >
    <div class="question-block">
      <div class="section-bg-contrast">
        <div class="question-header">
          <span>{{ titleKey | translate }}</span>
          <ng-container *ngIf="isAdmin">
            <button
              *ngIf="!edit.active"
              type="button"
              class="btn border-0"
              [attr.aria-label]="'button.edit' | translate"
              (click)="start()"
            >
              <i class="bi bi-pencil-fill" aria-hidden="true"></i>
            </button>
            <div *ngIf="edit.active" class="d-flex gap-2">
              <button
                type="button"
                class="btn btn-sm btn-primary"
                (click)="save()"
                [disabled]="edit.saving || edit.loadingOptions"
              >
                {{ 'button.save' | translate }}
              </button>
              <button
                type="button"
                class="btn btn-sm btn-outline-secondary"
                (click)="cancel()"
                [disabled]="edit.saving"
              >
                {{ 'button.cancel' | translate }}
              </button>
            </div>
          </ng-container>
        </div>
      </div>

      <div
        class="spinner-border text-info mb-3"
        role="status"
        *ngIf="edit.active && edit.loadingOptions"
      >
        <span class="visually-hidden">Loading...</span>
      </div>

      <app-form-field-select
        *ngIf="isAdmin && edit.active && !edit.loadingOptions"
        [field]="edit.control"
        [options]="edit.options"
        [label]="'label.dropdown-select'"
        [multiple]="true"
        [required]="false"
        [sortBy]="'translated-label-asc'"
      ></app-form-field-select>

      <ul *ngIf="!edit.active">
        <li *ngFor="let uni of items">
          {{ uni.translationKey | translate }}
        </li>
      </ul>
    </div>
  </ng-template>

  <xng-breadcrumb [separator]="separatorIconTemplate">
    <ng-container
      *xngBreadcrumbItem="
        let breadcrumb;
        let info = info;
        let first = first
      "
    >
      <i class="bi bi-info-circle-fill" *ngIf="info && info === 'info'" aria-label="Info"></i>
      <i class="bi bi-house-fill" *ngIf="info && info === 'home'" aria-label="Home"></i>
      <ng-container *ngIf="!first">
        {{ breadcrumb | translate }}
      </ng-container>
    </ng-container>
  </xng-breadcrumb>

  <ng-template #separatorIconTemplate>
    <i class="bi bi-caret-right-fill"></i>
  </ng-template>

  <h2 class="fs-3 fw-bold">{{ 'title.booking-summary' | translate }}</h2>

  <div class="d-flex flex-wrap" *ngIf="!isLoading">
    <div class="flex-1 d-flex flex-column p-2">
      <div *ngIf="booking">
        <img
          *ngIf="booking.test.logoPath"
          [src]="booking.test.logoPath"
          [alt]="booking.test.name"
          class="logo"
        />
        <div
          class="booking-data"
        >
          <p>
            {{ booking.test.name }}
          </p>
          <p>
          <span>
            {{
            'booking.default.summary.format.dayOfWeek'
              | translate
              : {
                timeSlot:
                  timeSlot | localizedDate: 'EEEE'
              }
            }}
            <strong>
              <time [dateTime]="timeSlotDate">{{
              'booking.default.summary.format.date'
                | translate
                : {
                  timeSlot:
                    timeSlot
                      | localizedDate: 'mediumDate'
                }
              }}</time>
            </strong>
          </span>
            <br />
            <span>{{
              'booking.default.summary.format.area.prefix'
                | translate
              }}</span>
            <strong>{{ examEvent.testarea }}</strong>
            <span>{{
              'booking.default.summary.format.area.suffix'
                | translate
              }}</span>
            <span>{{
              'booking.default.summary.format.time.prefix'
                | translate
              }}</span>
            <strong>
              <time [dateTime]="timeSlotTime">{{
              'booking.default.summary.format.time.format'
                | translate
                : {
                  timeSlot:
                    timeSlot | localizedDate: 'shortTime'
                }
              }}</time>
            </strong>
          </p>
          <p *ngIf="booking.requestedPayment">
            {{ 'label.test-event-price' | translate }}:
            <strong>{{
              booking.requestedPayment.amount
                | currency
                : examEvent.price.currency
                  : undefined
                  : undefined
                  : currentLanguage
              }}</strong>
          </p>
          <p
            *ngIf="!paymentCouldArriveShortly"
            class="d-flex justify-content-between"
          >
            <span
              class="border-start border-5 border-info ps-2"
              [class.border-warning]="booking.status === 'canceled' || (booking.status === 'open' && (booking.paymentExpectedUntil || !booking.requestedPayment))"
              [class.border-danger]="booking.deleted || booking.status === 'order_canceled'"
            >
              {{ 'label.payment-status' | translate }}:
              <span>
                <strong>
                  {{
                  'booking.default.status.' + booking.status
                    | lowercase
                    | translate
                  }}
                </strong>
              </span>
            </span>
            <button
              *ngIf="isAdmin && booking.status !== 'paid' && booking.status !== 'not_required' && booking.status !== 'order_canceled'"
              type="button"
              class="btn border-0"
              [tooltip]="'booking.default.summary.edit-status' | translate"
              (click)="changePaymentStatusDialog()"
            >
              <i class="bi bi-pencil-fill" aria-hidden="false" [attr.aria-label]="'booking.default.summary.edit-status' | translate"></i>
            </button>
          </p>

          <div class="spinner-border text-info mb-3" role="status" *ngIf="paymentCouldArriveShortly">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>

        <div
          class="section-bg-warning font-size-sm"
          *ngIf="canBePaidFor"
        >
          <div class="section-bg-warning-title">
            <strong>
              <i class="bi bi-exclamation-triangle-fill"></i>
              {{
              'booking.default.summary.booking-without-payment.title'
                | translate
              }}
            </strong>
          </div>

          <ng-container *ngIf="tenant !== 'sdv'">
            {{
              'booking.default.summary.booking-without-payment.held-until'
                | translate
                  : {
                      reservedUntil:
                        automaticCancelDate
                        | localizedDate: 'long'
                    }
            }}
          </ng-container>

          <ng-container *ngIf="tenant === 'sdv'">
            <ng-container *ngIf="!bookingPaymentExpectedUntil; else paymentDeadline">
              <p>
                <b>{{
                    'booking.sdv.summary.booking-without-payment.held-until.card-info.part-1'
                      | translate
                  }}</b>
                {{
                  'booking.sdv.summary.booking-without-payment.held-until.card-info.part-2'
                    | translate
                }}
              </p>
              <p>
                <b>{{
                  'booking.sdv.summary.booking-without-payment.held-until.sepa-info.part-1'
                    | translate
                }}</b>
                {{
                  'booking.sdv.summary.booking-without-payment.held-until.sepa-info.part-2'
                    | translate
                }}
                <b><u>{{
                  'booking.sdv.summary.booking-without-payment.held-until.sepa-info.part-3'
                    | translate
                }}</u></b>
              </p>
            </ng-container>

            <ng-template #paymentDeadline>
              <ng-container *ngIf="selectedPaymentMethod !== 'banktransfer'; else selectedBanktranser">
                <p>
                  {{
                    'booking.sdv.summary.booking-without-payment.held-until.card-info-deadline.part-1'
                      | translate : { paymentExpectedUntil: bookingPaymentExpectedUntil | localizedDate:'dd.MM.yyyy, HH:mm' }
                  }}
                </p>
              </ng-container>

              <ng-template #selectedBanktranser>
                <p>
                  {{
                    'booking.sdv.summary.booking-without-payment.held-until.sepa-info-deadline.part-1'
                      | translate : { paymentExpectedUntil: bookingPaymentExpectedUntil | localizedDate:'dd.MM.yyyy, HH:mm' }
                  }}
                </p>
                <p>
                  <b>{{
                    'booking.sdv.summary.booking-without-payment.held-until.sepa-info.part-1'
                      | translate
                  }}</b>
                  {{
                    'booking.sdv.summary.booking-without-payment.held-until.sepa-info-deadline.part-2'
                      | translate
                  }}
                  <b>{{
                    'booking.sdv.summary.booking-without-payment.held-until.sepa-info-deadline.part-3'
                      | translate
                  }}</b>
                </p>
              </ng-template>
            </ng-template>
          </ng-container>
        </div>

        <button
          class="btn btn-primary w-100 mb-1"
          *ngIf="canBePaidFor"
          (click)="doPayment()"
        >
          {{ 'button.new-payment' | translate }}
        </button>

        <div
          class="infotext border border-info border-3 p-3 rounded mb-3"
          *ngIf="infotextBlocks.length > 0"
        >
          <ng-container *ngFor="let block of infotextBlocks">
            <pre *ngIf="!blockStartsWithDot(block)" class="infotext-space"> </pre>
            <ng-container [ngSwitch]="block.type">
              <h2
                *ngSwitchCase="'HEADING'"
                class="infotext-heading"
              >{{ block.value }}</h2>
              <span
                *ngSwitchCase="'TEXT'"
                class="infotext-text"
                [class.fw-bold]="isBoldInfotext(block)"
                [class.fst-italic]="isItalicInfotext(block)"
                [class.infotext-underlined]="isUnderlinedInfotext(block)"
              >{{ block.value }}</span>
              <a
                *ngSwitchCase="'LINK'"
                class="infotext-link"
                [class.fw-bold]="isBoldInfotext(block)"
                [class.fst-italic]="isItalicInfotext(block)"
                [class.infotext-underlined]="isUnderlinedInfotext(block)"
                [href]="getLinkFromLinkBlock(block)"
              >{{ block.value }}</a>
              <br
                *ngSwitchCase="'LINE_BREAK'"
                class="infotext-linebreak"
              />
            </ng-container>
          </ng-container>
        </div>

        <div class="section-booking-history" *ngIf="isAdmin">
          <div class="section-booking-history-title">
            <strong>{{ 'booking.default.summary.history-events.titles.title' | translate }}</strong>
          </div>

          <app-exam-booking-history-table
            [bookingId]="booking.bookingId"
          >
          </app-exam-booking-history-table>
        </div>
      </div>

      <section *ngIf="tenant === 'sdv'">
        <app-add-questions-answers-overview
          [booking]="booking"
        ></app-add-questions-answers-overview>
      </section>

      <section *ngIf="tenant === 'sdv' && isOptionalQuestionAnswered">
        <app-optional-questions-answers-overview
          [booking]="booking"
        ></app-optional-questions-answers-overview>
      </section>
    </div>

    <ng-container [ngSwitch]="tenant">
      <div
        *ngSwitchCase="'default'"
        class="flex-1 d-flex flex-column p-2"
      >
        <ng-container
          *ngIf="showApplicationUniversities"
          [ngTemplateOutlet]="adminUniversitiesBlock"
          [ngTemplateOutletContext]="{
            titleKey: applicationUniversitiesTitleKey,
            edit: adminEdit.applicationUniversities,
            start: startAdminEditApplicationUniversities.bind(this),
            save: saveAdminEditApplicationUniversities.bind(this),
            cancel: cancelAdminEditApplicationUniversities.bind(this),
            items: userAnswers.universityIds
          }"
        ></ng-container>

        <ng-container
          *ngIf="showAutoSendUniversities"
          [ngTemplateOutlet]="adminUniversitiesBlock"
          [ngTemplateOutletContext]="{
            titleKey: autoSendUniversitiesTitleKey,
            edit: adminEdit.autoSendUniversities,
            start: startAdminEditAutoSendUniversities.bind(this),
            save: saveAdminEditAutoSendUniversities.bind(this),
            cancel: cancelAdminEditAutoSendUniversities.bind(this),
            items: userAnswers.sendResultsToUniversityIds
          }"
        ></ng-container>

        <ng-container
          [ngSwitch]="booking.test.templateName"
        >
          <ng-container *ngSwitchCase="'PhaST'">
            <div class="question-block">
              <div class="section-bg-contrast">
                <span>{{
                  'phast.question.final-grade.text'
                    | translate
                  }}</span>
              </div>
              <div class="plain-text-output">
                {{
                userAnswers.finalGrade
                  ? userAnswers.finalGrade
                  : ('label.not-specified' | translate)
                }}
              </div>
            </div>
            <!-- TODO Without functionality yet
          <button class="btn btn-primary">
          {{ 'button.edit' | translate }}
        </button> -->
          </ng-container>

          <ng-container *ngSwitchCase="'TM-WISO'">
            <ng-container
              [ngTemplateOutlet]="adminLanguageBlock"
              [ngTemplateOutletContext]="{
                titleKey: 'tm-wiso.questions.language.text',
                edit: adminEdit.language,
                start: startAdminEditLanguage.bind(this),
                save: saveAdminEditLanguage.bind(this),
                cancel: cancelAdminEditLanguage.bind(this)
              }"
            ></ng-container>

          </ng-container>

          <ng-container *ngSwitchCase="'GSAT'">
            <ng-container
              [ngTemplateOutlet]="adminLanguageBlock"
              [ngTemplateOutletContext]="{
                titleKey: 'gsat.questions.language.text',
                edit: adminEdit.language,
                start: startAdminEditLanguage.bind(this),
                save: saveAdminEditLanguage.bind(this),
                cancel: cancelAdminEditLanguage.bind(this)
              }"
            ></ng-container>
          </ng-container>

          <ng-container *ngSwitchCase="'ITB-Business'">
            <div class="question-block" *ngIf="userAnswers.variant">
              <div class="section-bg-contrast">
                <span>{{
                'itb-business.questions.variant.text' | translate
                }}</span>
              </div>
              <div class="plain-text-output">
                <span>{{
                  'itb-business.questions.variant.' + userAnswers.variant + '.complete' | translate
                }}</span>
              </div>
            </div>

            <ng-container
              [ngTemplateOutlet]="adminLanguageBlock"
              [ngTemplateOutletContext]="{
                titleKey: 'itb-business.questions.language.text',
                edit: adminEdit.language,
                start: startAdminEditLanguage.bind(this),
                save: saveAdminEditLanguage.bind(this),
                cancel: cancelAdminEditLanguage.bind(this)
              }"
            ></ng-container>

            <div class="question-block">
              <div class="section-bg-contrast">
                <span>{{
                  'itb-business.questions.final-grade.text'
                    | translate
                  }}</span>
              </div>
              <div class="plain-text-output">
                {{
                userAnswers.finalGrade
                  ? userAnswers.finalGrade
                  : ('label.not-specified' | translate)
                }}
              </div>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'ITB-Science'">
            <ng-container
              [ngTemplateOutlet]="adminLanguageBlock"
              [ngTemplateOutletContext]="{
                titleKey: 'itb-science.questions.language.text',
                edit: adminEdit.language,
                start: startAdminEditLanguage.bind(this),
                save: saveAdminEditLanguage.bind(this),
                cancel: cancelAdminEditLanguage.bind(this)
              }"
            ></ng-container>

            <div class="question-block">
              <div class="section-bg-contrast">
                <span>{{
                    'itb-science.questions.final-grade.text'
                      | translate
                  }}</span>
              </div>
              <div class="plain-text-output">
                {{
                  userAnswers.finalGrade
                    ? userAnswers.finalGrade
                    : ('label.not-specified' | translate)
                }}
              </div>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'ITB-Technology'">
            <ng-container
              [ngTemplateOutlet]="adminLanguageBlock"
              [ngTemplateOutletContext]="{
                titleKey: 'itb-technology.questions.language.text',
                edit: adminEdit.language,
                start: startAdminEditLanguage.bind(this),
                save: saveAdminEditLanguage.bind(this),
                cancel: cancelAdminEditLanguage.bind(this)
              }"
            ></ng-container>

            <div class="question-block">
              <div class="section-bg-contrast">
                <span>{{
                    'itb-technology.questions.apply-for-university.text'
                      | translate
                  }}</span>
              </div>
              <ul>
                <li
                  *ngFor="
                    let uni of userAnswers.universityIds
                  "
                >
                  {{ uni.translationKey | translate }}
                </li>
              </ul>
            </div>

            <div class="question-block">
              <div class="section-bg-contrast">
                <span>{{
                    'itb-technology.questions.send-results.text'
                      | translate
                  }}</span>
              </div>
              <ul>
                <li
                  *ngFor="
                    let uni of userAnswers.sendResultsToUniversityIds
                  "
                >
                  {{ uni.translationKey | translate }}
                </li>
              </ul>
            </div>

            <div class="question-block">
              <div class="section-bg-contrast">
                <span>{{
                    'itb-technology.questions.final-grade.text'
                      | translate
                  }}</span>
              </div>
              <div class="plain-text-output">
                {{
                  userAnswers.finalGrade
                    ? userAnswers.finalGrade
                    : ('label.not-specified' | translate)
                }}
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>

    <div
      [class.flex-1]="tenant === 'default'"
      class="d-flex flex-column p-2"
    >
      <div class="section-bg-contrast">
        <div class="section-bg-contrast-title">
          <strong>{{
            'title.downloads' | translate
            }}</strong>
        </div>

        <ng-container *ngIf="isAdmin">
          <ngx-file-drop
            class="booking-file-upload"
            (onFileDrop)="uploadFile($event)"
            (onFileOver)="setHoveringOverUpload(true)"
            (onFileLeave)="setHoveringOverUpload(false)"
            [directory]="false"
            [dropZoneLabel]="
              (isUploading
                ? 'file-upload.files-uploading'
                : 'file-upload.drop-files-here'
              ) | translate
            "
            [dropZoneClassName]="
              isHoveringOverUpload
                ? 'file-upload-drop-zone hovering-over-upload'
                : 'file-upload-drop-zone'
            "
            contentClassName="file-upload-content"
            [showBrowseBtn]="true"
            browseBtnClassName="file-upload-browse-btn section-bg-contrast-btn btn btn-primary"
            [browseBtnLabel]="
              'file-upload.browse-button-label' | translate
            "
            [multiple]="true"
          ></ngx-file-drop>

          <hr class="file-upload-separator" />
        </ng-container>

        <span *ngIf="bookingFiles === undefined">
          Die Dateien für diese Buchung werden geladen...
        </span>

        <span *ngIf="bookingFiles?.length === 0">
          Es stehen aktuell keine Downloads für diese
          Buchung zur Verfügung.
        </span>

        <div
          *ngFor="let bookingFile of bookingFiles"
          class="section-bg-contrast-list-entity d-flex justify-content-between"
        >
          <span class="text-break">
            {{ bookingFile.fileName }}
            ({{ fileSize(bookingFile) }})
          </span>
          <div class="d-flex flex-shrink-0 align-items-center gap-1">
            <button
              type="button"
              class="btn border-0 d-inline-flex align-items-center justify-content-center p-0 rounded-circle booking-file-action-btn"
              container="body"
              data-bs-placement="top"
              [tooltip]="'file-download.download-button' | translate: { fileName: bookingFile.fileName }"
              (click)="
                downloadFile(
                  bookingFile.internalFileId,
                  bookingFile.fileName
                )
              "
            >
              <i class="bi bi-download"></i>
            </button>
            <button
              type="button"
              class="btn border-0 d-inline-flex align-items-center justify-content-center p-0 rounded-circle booking-file-action-btn"
              container="body"
              data-bs-placement="top"
              [tooltip]="'file-download.delete-button' | translate: { fileName: bookingFile.fileName }"
              (click)="deleteFile(bookingFile)"
              *ngIf="isAdmin"
            >
              <i class="bi bi-trash"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="section-bg-contrast" *ngIf="isAdmin">
        <div class="section-bg-contrast-title">
          <strong>{{
            'title.booking-change-options' | translate
            }}</strong>
        </div>
        <button
          class="btn btn-outline-primary mb-3"
          [attr.aria-label]="'button.booking-change' | translate"
          (click)="changeBookingDialog()"
        >
          {{ 'button.booking-change' | translate }}
        </button>
        <button
          class="btn btn-outline-danger"
          [attr.aria-label]="'button.booking-cancel' | translate"
          (click)="cancelBookingDialog()"
          [disabled]="booking.status === 'order_canceled'"
        >
          {{ 'button.booking-cancel' | translate }}
        </button>
      </div>
    </div>
  </div>

  <app-loading-indicator-full
    *ngIf="isLoading"
  ></app-loading-indicator-full>
</div>
